const messages = {
    "dashboard": "Dashboard",
    "account": "Account",
    "signOut": "Uitloggen",
    "homepage": "Homepagina",
    "documentation": "Documentatie",
    "goToDocumentation": "Ga naar documentatie beheersysteem.",
    "appName": "Bestelsite Beheer Eataliano",
    "loading-title": "Laden...",
    "adminEnv": "Beheeromgeving",
    "toEatalianoHome": "Ga naar de homepagina van Eataliano.",
    "external": "Extern",
    "back": "Terug",
    "pickATab": "Kies een tab",
    "general": "Algemeen",
    "security": "Beveiliging",
    "signedInAs": "Ingelogd als: {user}",
    "error": "Error",
    "resetPassword": "Reset wachtwoord",
    "backToSignIn": "Terug naar inloggen?",
    "signIn": "Inloggen",
    "setPassword": "Wachtwoord instellen",
    "resetLinkExpired": "Resetlink verlopen?",
    "requestResetAgain": "Reset opnieuw aanvragen",
    "generalAccountDetails": "Algemene accountgegevens.",
    "emailAddress": "E-mailadres",
    "securitySettingsAccount": "Beveiligingsinstellingen voor jouw account.",
    "password": "Wachtwoord",
    "update": "Updaten",
    "passwordUpdated": "Wachtwoord opgeslagen!",
    "incorrectCurrentPassword": "Onjuiste huidige wachtwoord.",
    "errorUpdatingPassword": "Fout tijdens bijwerken wachtwoord.",
    "changePassword": "Wijzig wachtwoord",
    "cancel": "Annuleren",
    "save": "Opslaan",
    "enterFieldsToUpdatePassword": "Voer de velden hieronder in om jouw wachtwoord bij te werken.",
    "currentPassword": "Huidig wachtwoord",
    "newPassword": "Nieuw wachtwoord",
    "enterAPassword": "Voer een wachtwoord in.",
    "enterYourPassword": "Voer jouw wachtwoord in.",
    "enterAnEmailAddress": "Voer een e-mailadres in.",
    "mustBeMinCharacters": "Moet min. {min} karakter(s) bevatten.",
    "mustBeMaxCharacters": "Kan max. {max} karakter(s) bevatten.",
    "mustBeMinValue": "Waarde moet min. {min} zijn.",
    "mustBeMaxValue": "Waarde kan max. {max} zijn.",
    "weak": "Zwak",
    "ok": "Ok",
    "good": "Goed",
    "strong": "Sterk",
    "repeatPassword": "Herhaal wachtwoord",
    "repeatYourPassword": "Herhaal je wachtwoord.",
    "passwordsMustMatch": "Wachtwoorden moeten gelijk zijn.",
    "goToHomePage": "Naar homepagina gaan?",
    "passwordResetRequestedCheckInbox": "Wachtwoord reset aangevraagd. Check je inbox om verder te gaan.",
    "errorRequestingReset": "Fout bij wachtwoordreset aanvraag.",
    "emailAddressPlaceholder": "Voorbeeld@mail.nl",
    "emailAddressOfExistingAccount": "E-mailadres van bestaand account.",
    "requestReset": "Reset aanvragen",
    "couldNotResetPassword": "Kon wachtwoord niet resetten.",
    "errorSigningInAfterReset": "Fout tijdens inloggen na reset.",
    "invalidEmailOrPassword": "Onjuiste e-mailadres en/of wachtwoord.",
    "forgotPassword": "Wachtwoord vergeten?",
    "showPassword": "Toon wachtwoord",
    "hidePassword": "Verberg wachtwoord",
    "rememberMe": "Onthoud mij",
    "copyrightStatement": "© 2026 Eataliano Arnhem Noord B.V. & Eataliano Huissen B.V. Alle rechten voorbehouden",
    "lightMode": "Lichte modus",
    "darkMode": "Donkere modus",
    "resetPasswordInstructions": "Wachtwoord vergeten? Geen probleem! Voer jouw admin e-mailadres in en ontvang instructies om jouw wachtwoord opnieuw in te stellen.",
    "setPasswordInstructions": "Stel een nieuwe veilig wachtwoord in en klik op 'Opslaan'.",
    "change": "Wijzigen",
    "pageNotFound": "Pagina niet gevonden",
    "manageFromDashboard": "Beheeromgeving voor de bestelsite.",
    "rights": "Rechten",
    "restaurantMenu": "Restaurant menu",
    "openMenu": "Toon menu",
    "description": "Beschrijving",
    "pick-a-location": "Kies een locatie",
    "preferredLocation": "Voorkeurslocatie",
    "preferredLocation.tip": "Wijzigt automatisch zodra je een locatie kies (linksboven in dashboard).",
    "paginationSummary": "Toont {from} tot {to} van {total}",
    "date": "Datum",
    "log": "Log",
    "logs": "Logs",
    "status": "Status",
    "location": "Vestiging",
    "refreshStatus": "Status verversen",
    "systemError": "Systeem error!",
    "continue": "Doorgaan",
    "close": "Sluiten",
    "locationDetails": "Locatiegegevens",
    "employeeLogin": "Medewerker Login",
    "employeeCode": "Medewerkerscode",
    "employees": "Medewerkers",
    "employee": "Medewerker",
    "operationError": "Server error!",
    "name": "Naam",
    "firstName": "Voornaam",
    "lastName": "Achternaam",
    "code": "Code",
    "addedOn": "Toegevoegd",
    "view": "Bekijken",
    "copy": "Kopiëren",
    "copied": "Gekopieerd",
    "nItemsSelected": "{n} geselecteerd",
    "newEmployee": "Nieuwe medewerker",
    "timeRegistration": "Urenregistratie",
    "selectRow": "Selecteer rij",
    "selectAll": "Selecteer alles",
    "deselectAll": "Deselecteer alles",
    "id": "ID",
    "more": "Meer",
    "employeeLoginCodeTip": "Gebruik jouw 4-cijferige code om door te gaan.",
    "enter-required-field": "Voer verplicht veld in.",
    "pick-required-option": "Kies verplichte optie.",
    "enter-min-characters": "Minimaal {min} {min, plural, =1 {karakter} other {karakters}} vereist.",
    "enter-max-characters": "Maximaal {max} {max, plural, =1 {karakter} other {karakters}} toegestaan.",
    "value-must-be-min": "Waarde moet minimaal {min} zijn.",
    "value-within-max": "Waarde kan maximaal {max} zijn.",
    "enterValidCurrency": "Voer een geldig bedrag in (bijv.: \"10,99\", zonder euroteken).",
    "invalidEmployeeCode": "Deze code bestaat niet.",
    "employeeCodeToSignInWith": "Unieke medewerkerscode waarmee ze kunnen inloggen om in- en uit te klokken.",
    "employeeUnableToSignIn": "Kon niet inloggen.",
    "previousRegistrations": "Vorige registraties",
    "clockIn": "Inklokken",
    "clockOut": "Uitklokken",
    "clockedIn": "Ingeklokt",
    "clockedInOn2": "Ingeklokt om",
    "clockedInTime": "Ingeklokte tijd",
    "clockedInTimeDescription": "In onderstaande tabel kun je alle ingeklokte uren van deze werknemer terugzien. Indien iets niet klopt kun je het aanpassen dan wel verwijderen.",
    "clockedInOn": "Ingeklokt om {date}",
    "formattedClockedTime": "{hours}h {minutes}m {seconds}s",
    "formattedHoursMinutes": "{hours}h {minutes}m",
    "clockedOut": "Uitgeklokt",
    "clockedOutOn": "Uitgeklokt om",
    "employeeWithId": "Medewerker {employeeId}",
    "details": "Gegevens",
    "viewOrEditEmployeeDetails": "Bekijk of wijzig de medewerkergegevens.",
    "generalPersonData": "Algemene persoongegevens.",
    "internalIdReferencePurposes": "Interne ID voor referentie doeleinden.",
    "enterValidEmail": "Voer een geldig e-mailadres in.",
    "nOutOfTCharacters": "{n}/{t} karakter(s)",
    "phoneNumber": "Telefoonnummer",
    "saved": "Opgeslagen",
    "enterNDigits": "Enter {n} digits.",
    "codeInUser": "Deze code is al in gebruik.",
    "delete": "Verwijderen",
    "deleteEmployee": "Medewerker verwijderen",
    "confirmDeleteEmployee": "Weet je zeker dat je deze medewerker wilt verwijderen?",
    "employeeDeleted": "Medewerker verwijderd.",
    "required": "Verplicht",
    "workedHours": "Gewerkte uren",
    "notYetClockedOut": "Nog niet uitgeklokt",
    "options": "Opties",
    "edit": "Bewerken",
    "timeRegistrationDeleted": "Tijdregistratie verwijderd",
    "deleteTimeRegistration": "Tijdregistratie verwijderen",
    "editTimeRegistration": "Tijdregistratie bewerken",
    "confirmDeleteTimeRegistration": "Weet je zeker dat je deze tijdsregistratie wilt verwijderen?",
    "pickDate": "Kies datum",
    "pickStartDate": "Kies startdatum",
    "pickEndDate": "Kies einddatum",
    "clockOutMustBeBeforeClockIn": "Uitkloktijd moet na inkloktijd zijn.",
    "filterOnClocked": "Toon in- en/of uitgeklokte",
    "showAll": "Toon alles",
    "CLOCKED_IN": "Ingeklokt",
    "CLOCKED_OUT": "Uitgeklokt",
    "reports": "Rapportages",
    "timesheet": "Urenoverzicht",
    "total": "Totaal",
    "period": "Periode",
    "dateRange": "{from} t/m {to}",
    "dateRangeShort": "{from} - {to}",
    "numberOfEmployees": "Aantal medewerkers",
    "apply": "Toepassen",
    "today": "Vandaag",
    "yesterday": "Gisteren",
    "week": "Week",
    "month": "Maand",
    "quarter": "Kwartaal",
    "year": "Jaar",
    "pickARange": "Kies een periode",
    "pickADay": "Kies een dag",
    "newFeaturedProduct": "Nieuw uitgelicht product",
    "newLoyaltyReward": "Nieuw spaarproduct",
    "featuredProduct": "Uitgelicht product",
    "featuredProducts": "Uitgelichte producten",
    "featuredProductWithId": "Uitgelicht product {featuredProductId}",
    "viewOrEditFeaturedProduct": "Bekijk of wijzig de uitgelichte productgegevens.",
    "viewOrEditLoyaltyReward": "Bekijk of wijzig de gegevens van het spaarproduct.",
    "featuredProductEditDescription": "Geeft een beschrijving en koppel een product om deze te tonen als uitgelichte product op de website. Bijv. onder de sectie \"Populaire producten\".",
    "loyaltyRewardEditDescription": "Geeft de benodigde gegevens op en koppel een product om deze te tonen als inwisselbare product tegen spaarpunten op de website. Bijv. onder de sectie \"Actieproducten\".",
    "featuredProductDescriptionDescription": "Geeft een kort stukje tekst op (1 á 2 zinnen) om te tonen bij dit uitgelichte product.",
    "orderNumber": "Volgnummer",
    "featuredProductOrderNumberTip": "Uitgelichte producten worden gesorteerd o.b.v. een volgnummer van klein naar groot. Deze volgorde kun je ook vanuit de \"Uitgelichte producten\"-overzichtspagina specificeren.",
    "loyaltyRewardOrderNumberTip": "Spaarproducten worden gesorteerd o.b.v. een volgnummer van klein naar groot. Deze volgorde kun je ook vanuit de \"Spaarproducten\"-overzichtspagina specificeren.",
    "searchAProduct": "Zoek een product...",
    "product": "Product",
    "productIdAndExternal": "ID {productId} • Sitedish ID {productExternalId}",
    "noResults": "Géén resultaten",
    "featuredProductProductTip": "Kies een bestaand product om uit te lichten.",
    "closeMenu": "Sluit menu",
    "doesNotExistAnymore": "Bestaat niet meer",
    "dragRowsToChangeOrder": "Versleep de rijen om de volgorde te wijzigen",
    "saveOrder": "Volgorde opslaan",
    "featuredProductsExplanation": "Uitgelichte producten worden op verschillende plaatsen op de bestelsite in de spotlight gezet. Deze producten komen bijvoorbeeld tevoorschijn onder de sectie \"Populaire producten\" op de homepagina.",
    "loyaltyRewardsExplanation": "Spaarproducten worden op verschillende plaatsen op de bestelsite in de spotlight gezet als producten die inwisselbaar zijn tegen spaarpunten. De basisprijs van het product zal gratis zijn, eventuele toeslagen en extra's hanteren wel de reguliere prijzen.",
    "deleteFeaturedProduct": "Uitgelicht product verwijderen",
    "deleteLoyaltyReward": "Spaarproduct verwijderen",
    "confirmDeleteFeaturedProduct": "Weet je zeker dat je dit uitgelicht product wilt verwijderen? Het product zal dan niet meer in de spotlights worden gezet.",
    "confirmDeleteLoyaltyReward": "Weet je zeker dat je deze spaarproduct wilt verwijderen? Dit product kan dan niet meer tegen spaarpunten worden ingewisseld.",
    "deleted": "Verwijderd",
    "deliveryAreas": "Bezorggebieden",
    "newDeliveryArea": "Bezorggebied toevoegen",
    "editDeliveryArea": "Bezorggebied bewerken",
    "deliveryAreasExplanation": "Zowel in Mijn Sitedish als in deze beheeromgeving kun je bezorggebieden toevoegen. De bezorggebieden die je hier toevoegt, zullen daadwerkelijk worden gebruikt op de bestelwebsite. Dit is omdat er (nog) geen API-koppeling is met bezorggebieden tussen Sitedish en Eataliano.",
    "postalCode": "Postcode",
    "travelTimeMinutes": "Reistijd (minuten)",
    "travelTimeMinutesTip": "Aantal minuten dat een bezorger erover doet om naar deze postcode te reizen. Wordt gebruikt bij de berekening van voorgesteld bezorgtijden tijdens checkout.",
    "minimumOrderAmount": "Min. bestelbedrag",
    "deliveryFee": "Bezorgkosten",
    "deleteDeliveryArea": "Bezorggebied verwijderen",
    "confirmDeleteDeliveryArea": "Weet je zeker dat je \"{postalCode}\" voor {locationName} wilt verwijderen? Nieuwe bestellingen zullen deze postcode niet meer kunnen gebruiken om te laten bezorgen.",
    "saveAndClose": "Opslaan & sluiten",
    "deliveryAreaPostalCodeTip": "Vier cijfers van de postcode zonder letters.",
    "nMinutes": "{n} minuten",
    "enterValidPostalCode": "Voer een geldig postcode in (4 cijfers).",
    "busynessManagement": "Druktebeheer",
    "orderSiteStatus": "Bestelsite status",
    "orderSiteStatusDescription": "Stel in of de eataliano.nl moet weergeven dat het druk of gesloten is i.v.m. drukte.",
    "delivering": "Bezorging",
    "takingAway": "Afhaal",
    "delivery": "Bezorgen",
    "takeaway": "Afhalen",
    "DELIVERY": "Bezorgen",
    "TAKEAWAY": "Afhalen",
    "deliveryBusynessManagementByLocation": "Druktebeheer voor eataliano.nl bezorg-bestellingen door {location}.",
    "takeawayBusynessManagementByLocation": "Druktebeheer voor eataliano.nl afhaal-bestellingen bij {location}.",
    "busynessManagementExplanation": "De instellingen op deze pagina zijn bedoeld om de bestelsite aan te passen tijdens drukke momenten op de dag. Zo kun je de site sluiten voor nieuwe bezorg- en/of afhaal-bestellingen.",
    "normal": "Normaal",
    "busy": "Druk",
    "closed": "Gesloten",
    "fulfillmentStatusNormalExplanation": "Beschikbaar volgens reguliere openingstijden.",
    "fulfillmentStatusBusyExplanation": "Toont bezoekers meldingen dat het momenteel druk is. Bestelling plaatsen is mogelijk volgens reguliere openingstijden.",
    "fulfillmentStatusClosedExplanation": "Toon bezoekers meldingen dat online bestellen niet mogelijk is wegens drukte. Online bestellen is gesloten.",
    "manuallyRevert": "Handmatig terugdraaien",
    "manuallyRevertStatusExplanation": "Vergeet niet om deze instellingen handmatig terug te draaien naar \"Normaal\".",
    "no-email-address": "Géén e-mailadres",
    "no-phone-number": "Géén telefoonnummer",
    "system": "Systeem",
    "appInfo": "Applicaties",
    "appInfoDescription": "Huidige deployment versies.",
    "loyaltyReward": "Spaarproduct",
    "loyaltyRewards": "Spaarproducten",
    "loyaltyRewardWithId": "Spaarproduct {id}",
    "active": "Actief",
    "deactivated": "Gedeactiveerd",
    "loyaltyRewardActiveExplanation": "Klanten kunnen spaarpunten inruilen voor dit product.",
    "loyaltyRewardDeactivatedExplanation": "Spaarproduct niet inruilbaar of zichtbaar op de bestelsite.",
    "requiredPoints": "Benodigde punten",
    "requiredPointsExplanation": "Aantal punten nodig om in te ruilen tegen dit product. Klanten verdienen 1 punt per uitgegeven euro.",
    "paused": "Gepauzeerd",
    "clockedInAndOut": "In- en uitgeklokt",
    "export": "Exporteren",
    "exportHoursWorked": "Gewerkte uren exporten",
    "exportHoursWorked.description": "Ga door om een uren-export te starten voor {location} tussen {start} en {end}. Een CSV-bestand wordt gegenereerd en de download zal automatisch starten.",
    "downloadStartsImmediately": "Download begint ogenblikkelijk...",
    "jobOpenings": "Vacatures",
    "jobOpeningsExplanation": "In het onderstaande overzicht kun je vacatures markeren als openstaand of sluiten. Openstaande vacatures worden op eataliano.nl getoond.",
    "workAt": "Werken bij",
    "jobTitle": "Functietitel",
    "jobTitle.KITCHEN_STAFF": "Keukenmedewerker",
    "jobTitle.DISH_WASHER": "Afwasser",
    "jobTitle.WAITER": "Bediening",
    "jobTitle.DELIVERY_PERSON_SCOOTER": "Scooterbezorger",
    "jobTitle.DELIVERY_PERSON_BICYCLE": "Fietsbezorger",
    "jobTitle.DELIVERY_PERSON_CAR": "Autobezorger",
    "jobOpened": "Openstaand",
    "availability": "Beschikbaarheid",
    "lastActivatedOn": "Laatst geactiveerd",
    "lastDeactivatedOn": "Laatst gedeactiveerd",
    "jobApplications": "Sollicitaties",
    "jobApplication": "Sollicitatie",
    "filterOnStatus": "Filteren op status",
    "statusOpen": "Openstaand",
    "statusInProgress": "In behandeling",
    "statusClosed": "Gesloten",
    "receivedOn": "Ontvangen op",
    "showDetails": "Toon details",
    "motivation": "Motivatie",
    "internalNote": "Interne notitie",
    "detailsAlt": "Details",
    "noActions": "Géén acties",
    "generalDetails": "Algemene gegevens",
    "sentOn": "Verzonden op",
    "personalDetails": "Persoonsgegevens",
    "jobApplicationForm": "Sollicitatieformulier",
    "empty": "Leeg",
    "updateStatus": "Status bijwerken",
    "newStatus": "Nieuwe status",
    "copiedSuccessfully": "Tekst gekopieerd",
    "actions": "Acties",
    "sentByOn": "Verzonden door <bold>{from}</bold> om <bold>{date}</bold>:",
    "addInternalNote": "Interne notitie toevoegen",
    "openJobApplications": "Openstaande sollicitaties",
    "nOpenJobApplications": "{n} openstaande sollicitaties",
    "cv": "Cv",
    "download": "Downloaden",
    "pos": "POS",
    "new-order": "Nieuwe bestelling",
    "n-orders": "Bestellingen ({n})",
    "orders": "Bestellingen",
    "order": "Bestelling",
    "all": "Alles",
    "remove-search": "Zoekopdracht verwijderen",
    "search-orders-placeholder": "Zoek op no., naam, e-mail, tel., adres...",
    "pick-day": "Kies dag...",
    "payOnTakeaway": "Betalen bij afhalen",
    "payOnDelivery": "Betaling aan deur",
    "payment": "Betaling",
    "cancelled": "Geannuleerd",
    "cancelledRefunded": "Geannuleerd · terugbetaald",
    "cancelOrder": "Bestelling annuleren",
    "cancelOrderDescription": "De bestelling wordt geannuleerd en eventueel gespaarde of ingewisselde punten worden teruggedraaid. Dit kan niet ongedaan worden gemaakt.",
    "cancellationReason": "Reden van annulering",
    "cancellationReasonPlaceholder": "Bijv. klant heeft gebeld om te annuleren",
    "cancelPaidOnlineTitle": "Deze bestelling is online betaald",
    "cancelPaidOnlineDescription": "Betaal het bedrag handmatig terug via Mollie. Dit kan alleen door toegestane medewerkers gebeuren. Is dat al gedaan? Vink dan hieronder aan dat de bestelling is terugbetaald.",
    "alreadyRefunded": "Al terugbetaald via Mollie",
    "orderCancelled": "Bestelling geannuleerd",
    "cancelOrderFailed": "Annuleren van de bestelling is mislukt",
    "paidOnline": "Online betaald",
    "pos.order.open": "Bestelling {number} openen",
    "pos.order.requested": "Gewenst",
    "pos.order.late": "Te laat",
    "pos.order.asap": "Z.s.m.",
    "pos.order.delivery": "Bezorgen",
    "pos.order.takeaway": "Afhalen",
    "pos.order.placedAt": "Geplaatst {time}",
    "select-an-order": "Selecteer een bestelling",
    "select-an-order.description": "Klik op een bestelling uit het linkermenu om de gegevens ervan te zien.",
    "delivery-on": "Bezorgtijd",
    "takeaway-on": "Afhaaltijd",
    "orderedFromSource.POS": "Via handmatige invoer",
    "orderedFromSource.WEBSITE": "Via eataliano.nl",
    "order-n.delivery": "#{n} • Bezorging",
    "order-n.takeaway": "#{n} • Afhaal",
    "customer-details": "Klantgegevens",
    "payment-and-fulfillment": "Betaling & levering",
    "note": "Opmerking",
    "phone": "Tel. nr.",
    "email-address": "E-mailadres",
    "fulfillment": "Leverwijze",
    "requested-time": "Gekozen tijdstip",
    "customerPaysAtDoorstep": "Klant betaalt (PIN) aan de deur.",
    "customerPaysAtPickup": "Klant betaalt (PIN) bij het afhalen.",
    "organisationName": "Bedrijfsnaam",
    "cocNumber": "KvK-nummer",
    "vatNumber": "Btw-nummer",
    "deliveryAddress": "Bezorgadres",
    "formattedAddressLine1": "{street} {streetNumber}",
    "formattedAddressLine2": "{postalCodeDigits}{postalCodeLetters}, {city}",
    "noteColon": "Opmerking: {note}",
    "n-points": "{n} punten",
    "subtotal": "Subtotaal",
    "deposit": "Statiegeld",
    "plasticFee": "Plastic toeslag",
    "n-tip": "Fooi (+{n}%)",
    "redeemedPoints": "Gebruikte spaarpunten",
    "earnedPoints": "Verdiende spaarpunten",
    "totalInclTax": "Totaal (incl. btw)",
    "noNote": "Geen opmerking",
    "placedWithAccount": "Met account geplaatst",
    "placedWithoutAccount": "Zonder account geplaatst",
    "noteLeft": "Opmerking achtergelaten",
    "vatRate": "Btw-tarief",
    "vatLowAmount": "Bedrag excl. btw (9%)",
    "vatLow": "Btw 9%",
    "vatHighAmount": "Bedrag excl. btw (21%)",
    "vatHigh": "Btw 21%",
    "vatNone": "Bedrag zonder btw (0%)",
    "customerPaymentMethod": "Betalen bij levering",
    "printReceipt": "Print bon",
    "customerReceipt": "Klantbon",
    "kitchenReceipt": "Keukenbon",
    "deliveryReceipt": "Bezorgbon",
    "noOrdersYet": "Nog geen bestellingen",
    "noFilteredOrdersResults": "Geen bestellingen om weer te geven.",
    "noOrdersYetDescription": "Er zijn nog geen bestellingen binnengekomen vandaag.",
    "removeFilter": "Verwijder filter",
    "removeAllFilters": "Verwijder alle filters",
    "cannotLoadOrder": "Kan bestelling niet laden",
    "cannotLoadOrderDescription": "Error tijdens het laden van de bestelling. Mogelijk bestaat deze niet of heb je de verkeerde restaurant vestiging geselecteerd.",
    "orderCouldNotBeSaved": "Kon bestelling niet opslaan.",
    "bewareOfChangingFulfillment": "Waarschuwing voor wijzigen",
    "bewareOfChangingFulfillmentDescription": "Prijzen en aanbod van gerechten op het menu kunnen verschillen voor afhaal en bezorging. Na het plaatsen van de bestelling kun je dit daarom niet meer wijzigen.",
    "menu": "Menu",
    "posProductSearchPlaceholder": "Naam of beschrijving...",
    "posProductListInfo": "Sommige producten en/of categorieën kunnen slechts beschikbaar zijn op bepaalde dagen en/of tijden.",
    "soldOut": "Uitverkocht",
    "inStock": "Op voorraad",
    "productMarkedSoldOut": "Product staat op uitverkocht",
    "productMarkedInStock": "Product staat weer op voorraad",
    "productSoldOutExplanation": "Uitverkocht: kan niet worden besteld, ook niet op de bestelsite.",
    "productInStockExplanation": "Zet uit als het product op is; dan kan het nergens meer worden besteld.",
    "add": "Toevoegen",
    "allergens-dietary-preferences": "Allergenen en dieetwensen:",
    "flag.alcoholic": "Alcoholisch",
    "flag.hot": "Heet",
    "flag.spicy": "Pittig",
    "flag.mild": "Mild pittig",
    "flag.egg": "Ei",
    "flag.wheat": "Gluten (tarwe)",
    "flag.lupine": "Lupine",
    "flag.lactose": "Lactose",
    "flag.mustard": "Mosterd",
    "flag.nuts": "Noten",
    "flag.peanut": "Pinda's",
    "flag.shellfish": "Schaaldieren",
    "flag.celery": "Selderij",
    "flag.sesame": "Sesam",
    "flag.soya": "Soja",
    "flag.fish": "Vis",
    "flag.mollusc": "Weekdieren",
    "flag.sulphite": "Sulfieten",
    "flag.vegetarian": "Vegetarisch",
    "flag.vegan": "Vegan",
    "flag.halal": "Halal",
    "optional": "Optioneel",
    "optional-with-max": "Optioneel • Max. {n}",
    "free": "Gratis",
    "plus-price": "+ {price}",
    "minus-price": "{price}" /* No need to add minus sign, since the price already is minus */,
    "ex-deposit": "Ex. {price} statiegeld",
    "unavailable-for-DELIVERY": "Alléén bij afhaal",
    "unavailable-for-TAKEAWAY": "Alléén bij bezorging",
    "only-available-for.DELIVERY": "Alléén bij bezorging.",
    "only-available-for.TAKEAWAY": "Alléén bij afhaal.",
    "picked-item-names": "Gekozen voor: {items}",
    "n-of-total": "{n} van {total}",
    "choose": "Kiezen...",
    "alcoholCheck": "Alcohol-controle",
    "alcoholCheckInfo": "Let op: Klant moet 18+ zijn, ID-controle is verplicht.",
    "add-with-price": "Toevoegen • {price}",
    "addedToCart": "Toegevoegd aan winkelwagen.",
    "amountToOrder": "Aantal te bestellen",
    "price-ex-deposit-sup-fee": "Prijs ex. statiegeld en/of plastic-toeslag.",
    "unknownProduct": "Onbekend (product verwijderd)",
    "noProductsYet": "Geen producten",
    "noProductsYetDescription": "De winkelwagen is nog leeg.",
    "supFee": "Plastictoeslag (SUP)",
    "totalToPay": "Totaal te betalen",
    "pos.minimum.noPostalCode": "Vul een postcode in om bezorgkosten en het minimale bestelbedrag te bepalen.",
    "pos.minimum.outsideArea": "Deze postcode valt buiten het huidige bezorggebied.",
    "pos.minimum.below": "Minimaal bestelbedrag is {minimum}. Nog {remaining} te gaan.",
    "customerType": "Klant-type",
    "existingCustomer": "Bestaande klant",
    "existingCustomerDescription": "Bestel voor een bestaande klant. Je hoeft persoonsgegevens dan niet in te voeren",
    "withoutAccount": "Zonder account",
    "withoutAccountDescription": "Heeft de klant geen account? Gebruik dan deze optie.",
    "printJobQueued": "Printopdracht verzonden.",
    "printJobFailed": "Printopdracht kon niet worden verzonden.",
    "customer": "Klant",
    "selectCustomer": "Kies een klant.",
    "searching": "Zoeken...",
    "loyaltyPoints": "Spaarpunten",
    "businessDetails": "Zakelijke gegevens",
    "businessOrder": "Zakelijke bestelling",
    "businessOrderDescription": "De bedrijfsgegevens komen op de bestelling en de bon. Ze worden niet in het account van de klant opgeslagen.",
    "useBusinessDetailsOfAccount": "Gegevens uit account overnemen",
    "businessAddress": "Zakelijk adres",
    "businessAddressNotFilledIn": "Vul het adres in bij de zakelijke gegevens.",
    "deliverToBusinessAddress": "Bezorgen op zakelijk adres",
    "deliverToBusinessAddressDescription": "Vul het adres in bij de zakelijke gegevens hierboven.",
    "newAddress": "Nieuw adres",
    "newAddressDescription": "Bezorgen op een ander adres.",
    "addressName": "Naam adres",
    "addressNamePlaceholder": "Bijv. Thuis of Werk",
    "street": "Straat",
    "streetNumber": "Huisnummer",
    "postalCodeDigits": "Postcode-cijfers",
    "postalCodeLetters": "Postcode-letters",
    "postalCodeDigits.tip": "4 cijfers",
    "postalCodeLetters.tip": "2 letters",
    "city": "Plaats",
    "extraAddressInfo": "Extra adresinformatie",
    "extraAddressInfoPlaceholder": "Bijv. verdieping, bel of bedrijfsnaam",
    "invalidPostalCode": "Ongeldige postcode.",
    "takeawayAddress": "Afhaaladres",
    "restaurant": "Restaurant",
    "address": "Adres",
    "requestedDeliveryTime": "Bezorgtijd",
    "requestedPickupTime": "Afhaaltijd",
    "noTimeSlotsLeft": "Geen tijdstippen meer beschikbaar",
    "noTimeSlotsLeftDescription": "Er zijn vandaag geen tijdstippen meer binnen de openingstijden. Alleen z.s.m. is mogelijk.",
    "noteForKitchenAndCourier": "Opmerking voor keuken en bezorger",
    "notePlaceholder": "Bijv. niet aanbellen, baby slaapt",
    "placeOrder": "Bestelling plaatsen",
    "tip": "Fooi",
    "newTotal": "Nieuw totaal",
    "alreadyPaidOnline": "Al online betaald",
    "customerPaysExtra": "Klant betaalt {amount} bij (PIN)",
    "customerPaysExtraDescription": "Het nieuwe totaal is hoger dan wat online is betaald. Het verschil staat op de bezorg- en klantbon.",
    "customerGetsRefund": "Klant krijgt {amount} terug",
    "customerGetsRefundDescription": "Het nieuwe totaal is lager dan wat online is betaald. Betaal het verschil terug via Mollie.",
    "fulfillmentLocked": "Leverwijze kan niet worden gewijzigd",
    "fulfillmentLockedDescription": "Prijzen en aanbod van gerechten verschillen voor afhaal en bezorging. Wil de klant toch anders? Annuleer de bestelling en plaats een nieuwe.",
    "orderOfAccount": "Bestelling van een klantaccount",
    "orderWithoutAccount": "Bestelling zonder account",
    "accountCannotBeChanged": "Het account van een geplaatste bestelling kan niet worden gewijzigd.",
    "saveChanges": "Wijzigingen opslaan",
    "redeemedWithLoyaltyPoints": "Ingewisseld met spaarpunten",
    "postalCodeLookupLoading": "Adres zoeken...",
    "postalCodeSuggestion": "Suggestie: {street}, {city}",
    "postalCodeLookupNotFound": "Geen adres gevonden bij deze postcode. Vul straat en plaats zelf in.",
    "shoppingCart": "Winkelwagen",
    "newOrderReceiptPrintInfo": "Keukenbon wordt na opslaan geprint.",
    "existingOrderReceiptPrintInfo": "Nieuwe bon wordt niet automatisch geprint. Doe dat handmatig na opslaan indien nodig.",
    "cancelAndReturn": "Annuleer en terug",
    "discardChangesConfirm": "Je wijzigingen worden niet opgeslagen. Weet je zeker dat je wilt annuleren?",
    "no": "Nee",
    "cancelChanges": "Wijzigingen annuleren",
    "confirmCancel": "Ja, annuleren",
    "search": "Zoeken",
    "searchCustomerButton": "Klant zoeken",
    "chooseOtherCustomer": "Andere klant kiezen",
    "searchCustomerPlaceholder": "Naam, e-mailadres of telefoonnummer",
    "searchCustomerHint": "Typ minimaal 2 tekens en druk op Enter of op Zoeken.",
    "searchCustomerFailed": "Er ging iets mis bij het zoeken. Probeer het opnieuw.",
    "noCustomersFound": "Geen klanten gevonden",
    "noCustomersFoundDescription": "Controleer de spelling of zoek op iets anders, zoals het telefoonnummer.",
    "selectThisCustomer": "Klant kiezen",
    "deliveryAddresses": "Bezorgadressen",
    "printDeliveryReceipt": "Bezorgbon printen",
    "linkCourierDescription": "Vul je medewerkerscode in. De bestelling wordt dan aan jou als bezorger gekoppeld.",
    "currentCourier": "Nu gekoppeld aan {name}. Met een andere code koppel je een andere bezorger.",
    "linkAndPrint": "Koppelen en printen",
    "printWithoutLinking": "Printen zonder koppelen",
    "courier": "Bezorger",
    "noCourierLinked": "Nog niet gekoppeld",
    "dayReport": "Dagrapportage",
    "pos.order.present": "Is er al",
    "paymentStatus": "Betaalstatus",
    "paidInRestaurant": "Betaald in restaurant",
    "paidInRestaurantDescription": "De klant heeft al betaald (PIN) aan de balie.",
    "alreadyPaidInRestaurant": "Al betaald in het restaurant",
    "alreadyPaidInRestaurantDescription": "De klant betaalde {amount}. Wijzigt het totaal, reken het verschil dan aan de balie af.",
    "newCategory": "Nieuwe categorie",
    "menuCard": "Menukaart",
    "menuCard.description": "Hieronder volgen alle categorieën op het menukaart. Deze categorieën en producten daarbinnen kun je beheren.",
    "optionGroups": "Keuzemenu's",
    "optionGroup": "Keuzemenu",
    "optionGroups.description": "Hieronder volgen alle keuzemenu's, zoals sauzen of extra toppings, met de opties daarbinnen. Een optie die in meerdere keuzemenu's staat, verwijder je alleen uit het gekozen keuzemenu.",
    "optionGroupType.required": "Verplicht · kies 1",
    "optionGroupType.optional": "Optioneel · max. {max}",
    "optionGroupType.optionalUnlimited": "Optioneel · onbeperkt",
    "usedByProducts": "Bij {count, plural, =0 {geen producten} one {# product} other {# producten}}",
    "noOptionsInGroup": "Dit keuzemenu heeft nog geen opties.",
    "noOptionGroups": "Er zijn nog geen keuzemenu's.",
    "alsoInOtherGroups": "Ook in {count, plural, one {# ander keuzemenu} other {# andere keuzemenu's}}",
    "onlyDelivery": "Alleen bezorgen",
    "onlyTakeaway": "Alleen afhalen",
    "notAvailable": "Niet beschikbaar",
    "priceDelivery": "Prijs bezorgen",
    "priceTakeaway": "Prijs afhalen",
    "vat": "Btw",
    "removeOption": "Optie verwijderen",
    "confirmRemoveOption": "Weet je zeker dat je {option} uit keuzemenu {group} wilt verwijderen?",
    "confirmRemoveOption.otherGroups": "De optie blijft in de andere keuzemenu's staan.",
    "newDish": "Nieuw gerecht",
    "editDish": "Gerecht bewerken",
    "productOrdering": "Gerecht volgorde",
    "planning": "Planning",
    "deliveryPrice": "Bezorg-prijs",
    "takeawayPrice": "Afhaal-prijs",
    "updateProductCustomerSiteInfo": "Het kan enige tijd duren voordat wijzigingen zichtbaar zijn op de klantensite.",
    "yes": "Ja",
    "stockStatus": "Voorraad",
    "allergensAndDiet": "Allergenen en dieetwensen",
    "productNotOrderable": "Zonder bezorgen of afhalen is het gerecht niet te bestellen.",
    "searchOrChoose": "Zoeken of kiezen...",
    "nChosen": "{count} gekozen",
    "nOptions": "{count, plural, one {# optie} other {# opties}}",
    "noOptionGroupsLinked": "Er zijn nog geen keuzemenu's gekoppeld.",
    "optionGroupsOrder.tip": "De keuzemenu's worden in deze volgorde bij het gerecht getoond.",
    "moveUp": "Omhoog",
    "moveDown": "Omlaag",
    "unlink": "Ontkoppelen",
    "day.monday": "Maandag",
    "day.tuesday": "Dinsdag",
    "day.wednesday": "Woensdag",
    "day.thursday": "Donderdag",
    "day.friday": "Vrijdag",
    "day.saturday": "Zaterdag",
    "day.sunday": "Zondag",
    "planningOf": "Planning {category}",
    "planning.description": "Kies per dag wanneer deze categorie op de menukaart staat. Zonder aangepaste tijden is de categorie de hele dag beschikbaar.",
    "planning.allDay": "Hele dag beschikbaar",
    "planning.custom": "Aangepast",
    "planning.mode": "Beschikbaarheid",
    "planning.mode.times": "Vanaf en/of tot tijdstip",
    "planning.mode.closed": "Niet beschikbaar",
    "planning.from": "Vanaf",
    "planning.until": "Tot",
    "planning.enterFromOrUntil": "Vul een vanaf- en/of tot-tijdstip in.",
    "planning.fromBeforeUntil": "Het vanaf-tijdstip moet voor het tot-tijdstip liggen.",
    "planning.startOfDay": "Begin van de dag",
    "planning.endOfDay": "Einde van de dag",
    "type": "Type",
    "newOptionGroup": "Nieuw keuzemenu",
    "editOptionGroup": "Keuzemenu bewerken",
    "maxOptions": "Max. aantal keuzes",
    "maxOptions.tip": "0 is onbeperkt.",
    "sortAlphabetically": "Sorteer A-Z",
    "addOption": "Optie toevoegen",
    "newOption": "Nieuwe optie",
    "new": "Nieuw",
    "optionsInGroup.tip": "Verwijderen haalt een optie alleen uit dit keuzemenu, de optie zelf blijft bestaan. Wijzigingen worden pas bij opslaan doorgevoerd.",
    "optionPrice.tip": "Een negatieve prijs is een korting, bijv. bij 'zonder kaas'.",
    "optionNotOrderable": "Zonder bezorgen of afhalen is de optie niet te kiezen.",
    "searchOptionGroups": "Zoek een keuzemenu...",
    "takeawayCustomerPresent": "Klant is er al",
    "emptyOrValidMailAddress": "Leeg laten óf een volledig geldig e-mailadres.",
    "": "",
    // "": "",
};

/*
const intl = useIntl();
intl.formatMessage({id: ""})
<FormattedMessage id={""}/>
 */

export default messages;